export default class NodeTypes {
    static Note = 'note';

    static Reference = 'reference';

    static Area = 'area';
}
